<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="row">
        <div class="col-xs-6">
          <h1>Banner Images for {{ titleName }}</h1>
        </div>
        <div class="col-xs-4 pull-right">
          <router-link
            v-if="bannerApprovalStatus != 3"
            :to="{
              name: 'AddBannerImage',
              params: { banner_id: banner_id, name: titleName },
            }"
            class="btn btn-sm btn-add"
          >
            <i class="fa fa-plus-square"></i> Add Banner Image
          </router-link>
          <a class="btn btn-sm btn-add refresh" @click="refreshNow">
            <i class="fa fa-refresh"></i> Refresh
          </a>
        </div>
      </div>
    </section>
    <section class="content">
      <form v-on:submit.prevent="dopagination(0)">
        <div class="row">
          <div class="col-xs-6 col-sm-3 form-group">
            <select
              v-model="imagePlatform"
              v-select="imagePlatform"
              class="form-control input-sm select2"
              @change="dopagination(0)"
              name="imagePlatform"
              id="imagePlatform"
            >
              <option value="">Select Platform</option>
              <option value="1">Android</option>
              <option value="2">iOS</option>
              <option value="3">Windows</option>
              <option value="4">MacOS</option>
            </select>
          </div>
          <div class="col-xs-6 col-md-3 form-group">
            <select
              v-model="imageStatus"
              v-select="imageStatus"
              class="form-control input-sm select2"
              @change="dopagination(0)"
              name="imageStatus"
              id="imageStatus"
            >
              <option value="">Select Status</option>
              <option value="1">Active</option>
              <option value="0">Pending</option>
              <option value="2">Rejected</option>
            </select>
          </div>
          <div class="col-xs-6 col-md-3 form-group" style="margin-bottom: 0">
            <select
              title=""
              name="limit"
              id="limit"
              class="form-control input-sm select2"
              @change="dopagination(0)"
              v-model="display_limit"
              v-select="display_limit"
            >
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="75">75</option>
              <option value="100">100</option>
            </select>
          </div>
          <div class="col-xs-6 col-md-3 ZRP form-group btnLeft">
            <a
              class="btn btn-sm btn-search"
              id="apply"
              @click="dopagination(0)"
            >
              <i class="fa fa-search"></i> Search
            </a>
          </div>
        </div>
      </form>
      <div class="row">
        <div class="col-sm-12">
          <div class="alert alert-info" v-if="alert_message">
            {{ alert_message }}
          </div>
        </div>
        <div class="col-md-12">
          <div class="box" id="pagination">
            <div class="box-header">
              <h3 class="box-title">
                Total : {{ totalData }} Showing {{ dispplayFrom }} to
                {{ dispplayTo }}
              </h3>
            </div>
            <div class="box-body">
              <div class="table-responsive">
                <table class="table table-0024 table-bordered table-striped">
                  <thead>
                    <tr>
                      <th class="tdCenter tdSN">SN</th>
                      <th class="tdCenter">Image</th>
                      <th class="tdCenter">Platform</th>
                      <th class="tdCenter">Status</th>
                      <th class="tdCenter">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(data, index) in bannerImageList" :key="data.id">
                      <td class="tdCenter tdSN">
                        {{ parseInt(sl) + parseInt(index) }}
                      </td>
                      <td class="tdCenter">
                        <img
                          v-if="data.img"
                          :src="data.img"
                          alt="Banner Image"
                          class="img-responsive img-thumbnail"
                          style="max-height: 80px"
                        />
                        <span v-else>No Image</span>
                      </td>
                      <td class="tdCenter">
                        <span v-if="data.device_type == '1'">Android</span>
                        <span v-else-if="data.device_type == '2'">iOS</span>
                        <span v-else-if="data.device_type == '3'">Windows</span>
                        <span v-else-if="data.device_type == '4'">MacOS</span>
                        <span v-else>Unknown</span>
                      </td>
                      <td class="tdCenter">
                        <span
                          v-if="data && data.is_active == 1"
                          class="label label-success"
                          >Active</span
                        >
                        <span
                          v-else-if="data && data.is_active == 0"
                          class="label label-danger"
                          >Inactive</span>
                        <span
                          v-else-if="data && data.is_active == 2"
                          class="label label-warning"
                          >In review</span
                        >
                        <span v-else class="label label-danger">Rejected</span>
                      </td>
                      <td class="tdCenter">
                        <template v-if="data.is_active == 1 || data.is_active == 0">
                          <router-link
                            :to="{
                              name: 'EditBannerImage',
                              params: {
                                id: data.id,
                                banner_id: banner_id,
                                name: titleName,
                              },
                            }"
                            title="Edit"
                          >
                            <i
                              class="ion ion-ios-compose table-edit"
                            ></i> </router-link
                          >&nbsp;
                        </template>
                        <template v-else>
                          <span class="text-danger"
                            >Can't edit</span
                          >&nbsp;
                        </template>
                      </td>
                    </tr>
                    <tr v-if="bannerImageList.length == 0">
                      <td colspan="10" class="tdCenter" style="padding: 30px 0">
                        <b>No Records Found</b>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="pagination" v-if="last_page > 1">
                <a
                  v-if="prev_page_url"
                  href="#"
                  @click="dopagination(prevPage)"
                  class="next"
                >
                  « Previous
                </a>
                <span v-else class="disabled">« Previous</span>
                <span v-if="last_page > max_display_pagination">
                  <span v-for="index in last_page">
                    <span v-if="index == 1 || index == 2">
                      <span class="current" v-if="index == current_page">
                        {{ index }}
                      </span>
                      <span v-else>
                        <a href="#" @click="dopagination(index)">
                          {{ index }}
                        </a>
                      </span>
                      <span v-if="index == 2 && firstDotted">..</span>
                    </span>
                    <span v-if="randomPageNumber.includes(index)">
                      <span class="current" v-if="index == current_page">
                        {{ index }}
                      </span>
                      <span v-else>
                        <a href="#" @click="dopagination(index)">
                          {{ index }}
                        </a>
                      </span>
                    </span>
                    <span v-if="index == last_page || index == last_page - 1">
                      <span v-if="index == last_page - 1 && lastDotted">
                        ..
                      </span>
                      <span class="current" v-if="index == current_page">
                        {{ index }}
                      </span>
                      <span v-else>
                        <a href="#" @click="dopagination(index)">
                          {{ index }}
                        </a>
                      </span>
                    </span>
                  </span>
                </span>
                <span v-else>
                  <span v-for="index in last_page">
                    <span class="current" v-if="index == current_page">
                      {{ index }}
                    </span>
                    <span v-else>
                      <a href="#" @click="dopagination(index)">{{ index }}</a>
                    </span>
                  </span>
                </span>
                <a
                  v-if="next_page_url"
                  href="#"
                  @click="dopagination(nextPage)"
                  class="next"
                >
                  Next »
                </a>
                <span v-else class="disabled">Next »</span>
              </div>
            </div>
            <div class="box-footer"></div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "BannerImages",
  data() {
    return {
      description: "",
      bannerImageList: [],
      bannerApprovalStatus: 0,
      imagePlatform: 1,
      titleName: "",
      banner_id: null,
      alert_message: "",
      dispplayFrom: 0,
      dispplayTo: 0,
      totalData: 0,
      display_limit: 50,
      imageStatus: "",
      sl: 1,

      // Pagination Variables
      prev_page_url: false,
      next_page_url: false,
      last_page: 1,
      current_page: null,
      max_display_pagination: 9,
      randomPageNumber: {},
      firstDotted: false,
      lastDotted: false,
      prevPage: "",
      nextPage: "",
    };
  },
  created() {
    this.banner_id = this.$route.params.id;
    this.titleName = this.$route.params.name;
    this.dopagination(0);
  },
  methods: {
    dopagination(page_no = "") {
      loader.show();
      var rootObject = this;

      let querystr = "paginate=" + this.display_limit;

      if (page_no > 0) {
        querystr += "&page=" + page_no;
      }
      //console.log(querystr);

      axios
        .post("get-banner-images?" + querystr, {
          offer_banner_id: this.banner_id,
          device_type: this.imagePlatform,
          status: this.imageStatus,
        })
        .then(function (response) {
          // console.log(response, "response");
          rootObject.bannerApprovalStatus =
            response.data.banner_approval_status ?? 0;
          rootObject.populateBannerImageListData(response.data.data);
        })
        .catch(function (error) {
          let alertmessage = "";
          for (var prop in error.response.data) {
            alertmessage += " " + error.response.data[prop];
          }
          loader.hide();
          rootObject.com_errorHandel(error);
        });
    },

    populateBannerImageListData(response) {
      var responseData = response.data;
      this.sl = parseInt(responseData.from);
      this.bannerImageList = responseData.data;

      this.pinStatusArr = response.data.dnsSubscriberData;
      // this.subscribeStatuArr = response.data.dnsBatchData.lotsSubscriptionPinsArray;

      this.totalData = responseData.total;
      this.dispplayFrom = responseData.from;
      this.dispplayTo = responseData.to;
      this.display_limit = responseData.per_page;
      this.paginationGenerate(responseData);
      loader.hide();
    },

    paginationGenerate(response) {
      this.prev_page_url = response.prev_page_url;
      this.next_page_url = response.next_page_url;
      this.last_page = response.last_page;
      this.current_page = response.current_page;
      this.randomPageNumber = [];
      this.firstDotted = false;
      this.lastDotted = false;
      this.prevPage = this.current_page - 1;
      this.nextPage = this.current_page + 1;
      let countableOtherPages = this.max_display_pagination - 4;
      if (this.current_page == 1 || this.current_page == 2) {
        for (let i = 3; i <= 3 + (countableOtherPages - 1); i++) {
          this.randomPageNumber.push(i);
        }
        this.lastDotted = true;
      } else if (
        this.current_page == this.last_page ||
        this.current_page == this.last_page - 1
      ) {
        let endPage = this.last_page - 2;
        for (let i = endPage; i >= endPage - (countableOtherPages - 1); i--) {
          this.randomPageNumber.push(i);
        }
        this.firstDotted = true;
      } else {
        let interval = parseInt(countableOtherPages / 2);
        if (this.current_page <= interval + 3) {
          for (let i = 3; i <= 3 + (countableOtherPages - 1); i++) {
            this.randomPageNumber.push(i);
          }
          this.lastDotted = true;
        } else if (this.current_page >= this.last_page - (interval + 2)) {
          let endPage = this.last_page - 2;
          for (let i = endPage; i >= endPage - (countableOtherPages - 1); i--) {
            this.randomPageNumber.push(i);
          }
          this.firstDotted = true;
        } else {
          for (
            let i = this.current_page;
            i <= this.current_page + interval;
            i++
          ) {
            this.randomPageNumber.push(i);
          }

          for (
            let i = this.current_page - 1;
            i >= this.current_page - interval;
            i--
          ) {
            this.randomPageNumber.push(i);
          }
        }
      }
      //console.log(this.randomPageNumber);
    },

    refreshNow() {
      this.display_limit = 50;
      this.status = "";
      this.imagePlatform = 1;
      this.dopagination();
    },
  },

  mounted: function () {
    $(".select2").select2();
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
